import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthenticationService {
  serviceUrl = environment.serviceUrl;
  constructor(private http: HttpClient) { }

  login(username: string, password: string) {
    var serviceUrl = environment.serviceUrl + 'login';
    return this.http.post<any>(serviceUrl, { userName: username, password: password })
      .pipe(map(user => {
        // login successful if there's a jwt token in the response
        if (user && user.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          sessionStorage.setItem('currentUser', JSON.stringify(user));
        }

        return user;
      }));
  }

  logout() {  
    sessionStorage.removeItem('currentUser');
    sessionStorage.clear();
    localStorage.clear();
  }

  logoutservice(){
   // alert('OKKKK');
    let data = { 'name': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MDE0NTc2NTIsImV4cCI6MTcwMzE1OTExMDM4Mn0.6ubemoVvKVtpktjajDRWX7s73VAUZCPFGsboA5PljY8' }
    return this.http.post(this.serviceUrl + `logout`, data);
  }
}
